 angular
   .module('vppApp')
   .service('ScrollToService', ScrollToService);

 ScrollToService.$inject = ['$window', 'scrollToOptions'];



 function ScrollToService($window, scrollToOptions) {

   this.idOrName = function(offset, focus) { //find element with the given id or name and scroll to the first element it finds
     var document = $window.document;

     var idOrName = window.localStorage['idOrName_'];

     var dl = getParameterByName('dl');

     if(dl){
      idOrName = dl;
     }


     if (!idOrName) { //move to top if idOrName is not provided
       $window.scrollTo(0, 0);

     }

     if (focus === undefined) { //set default action to focus element
       focus = true;
     }

     //check if an element can be found with id attribute
     var el = document.getElementById(idOrName);
     if (!el) { //check if an element can be found with name attribute if there is no such id

       el = document.getElementsByName(idOrName);

       if (el && el.length) {
         el = el;
       } else {
         el = null;
       }
     }

     if (el) { //if an element is found, scroll to the element
       if (focus) {
         el.focus();
       }
       scrollToOptions.handler(el, offset);
       window.localStorage.removeItem("idOrName_");
     }
     
     
   }
 };
